import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ApiClientService} from '../../services/api-client.service';

declare const toastr: any;
declare const moment: any;

@Component({
    selector: 'parking-passes-filter',
    templateUrl: './parking-passes-filter.component.html',
    styleUrls: ['./parking-passes-filter.component.scss']
})
export class ParkingPassesFilterComponent implements OnInit {
    showDropdown = false;
    startDate = '';
    endDate = '';
    @ViewChild('currentCheckbox') current: ElementRef;
    @ViewChild('pendingCheckbox')  pending:  ElementRef;
    @ViewChild('futureCheckbox') future: ElementRef;
    @ViewChild('pastCheckbox') past: ElementRef;
    @ViewChild('declinedCheckbox') declined: ElementRef;
    @ViewChild('startDateCheckbox') startDateCheckbox: ElementRef;
    @ViewChild('endDateCheckbox') endDateCheckbox: ElementRef;
    constructor(private urlService: UrlService,
                public api: ApiClientService) {
    }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {

            const status = this.urlService.queryParams['status'];
            if (status) {
                this.current.nativeElement.checked = status.indexOf('current') !== -1;
                this.pending.nativeElement.checked = status.indexOf('pending') !== -1;
                this.future.nativeElement.checked = status.indexOf('future') !== -1;
                this.past.nativeElement.checked = status.indexOf('past') !== -1;
                this.declined.nativeElement.checked = status.indexOf('declined') !== -1;
            } else {
                this.current.nativeElement.checked = false;
                this.pending.nativeElement.checked = false;
                this.future.nativeElement.checked = false;
                this.past.nativeElement.checked = false;
                this.declined.nativeElement.checked = false;
            }

            const periodStartDate = this.urlService.queryParams['periodStartDate'];
            const periodEndDate = this.urlService.queryParams['periodEndDate'];
            if(periodStartDate)
                this.startDate = moment(periodStartDate)._d;
            if(periodEndDate)
                this.endDate = moment(periodEndDate).add(-1, 'day')._d;
        });

    }

    changeFilter() {
        const currentValue = this.current.nativeElement.checked;
        const pendingValue = this.pending.nativeElement.checked;
        const futureValue = this.future.nativeElement.checked;
        const pastValue = this.past.nativeElement.checked;
        const declinedValue = this.declined.nativeElement.checked;

        if (!currentValue && !pendingValue && !futureValue && !pastValue && !declinedValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (currentValue) status += 'current,';
            if (pendingValue) status += 'pending,';
            if (futureValue) status += 'future,';
            if (pastValue) status += 'past,';
            if (declinedValue) status += 'declined,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }

        if (!this.startDate && !this.endDate) {
            this.urlService.queryParams['periodStartDate'] = null;
            this.urlService.queryParams['periodEndDate'] = null;
        } else {
            if (this.startDate)
                this.urlService.queryParams['periodStartDate'] = moment(this.startDate).format('YYYY-MM-DD');
            if (this.endDate)
                this.urlService.queryParams['periodEndDate'] = moment(this.endDate).add(1, 'day').format('YYYY-MM-DD');
        }
        this.urlService.setQueryParams(null, 1);
    }

    onStartDateChange() {
        if(this.startDate > this.endDate) {
            this.endDate = '';
            this.urlService.queryParams['periodEndDate'] = null;
        }
    }

    clearDates() {
        this.startDate = '';
        this.endDate = '';
        this.changeFilter();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('parking-passes-filter') &&
            !targetElement.closest('.cdk-overlay-container') &&
            !targetElement.closest('.mat-calendar-body-cell-content')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/parking-passes-filter/parking-passes-filter.component.ts